import FetchContent from './fetchContent';

class FetchMenus extends FetchContent {
  async run() {
    this.response = await this.model.fetch('menus/?fields=*');
    return this.response;
  }
}
export default FetchMenus;
